import React, { createContext, useContext, useState } from 'react';

export type Theme = {
  felt: string;
  tableBase: string;
  accent: string;
  chipColors: string[];
  cardBack: string;
  metal: string;
};

const defaultTheme: Theme = {
  felt: '#0A5C36',
  tableBase: '#2B1B0F',
  accent: '#B76E79',
  chipColors: ['#FF6B6B', '#3B82F6', '#10B981', '#F59E42'],
  cardBack: '#1E293B',
  metal: '#B76E79',
};

const ThemeContext = createContext<{ theme: Theme; setTheme: (t: Theme) => void }>({ theme: defaultTheme, setTheme: () => {} });

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [theme, setTheme] = useState<Theme>(defaultTheme);
  return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => useContext(ThemeContext);
